"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var UserMessage_1 = require("../model/UserMessage");

var UserMessageFlag_1 = require("../model/UserMessageFlag");

var UserMessageConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(UserMessageConverter, _DataObjectConverter_);

  function UserMessageConverter() {
    _classCallCheck(this, UserMessageConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserMessageConverter).apply(this, arguments));
  }

  _createClass(UserMessageConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new UserMessage_1.UserMessage(UserMessage_1.UserMessage.schema.severity.valueOfField(source, 'severity'), UserMessage_1.UserMessage.schema.code.valueOfField(source, 'code'), conversions.asObjectList(source, 'args', function (value) {
        return value;
      }), conversions.asFlagSet(source.flags, UserMessageFlag_1.UserMessageFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        severity: source.severity,
        code: source.code,
        args: source.args.toArray(),
        flags: source.flags.serialize()
      };
    }
  }]);

  return UserMessageConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.UserMessageConverter = UserMessageConverter;